<div *appIsClient appFlexLayout="row" class="w-100-p">

  <div *ngIf="(organizationsService?.selectedOrganizationArray$|async)" class="organizations-list w-50-p">
    <mat-chip-set #chipList class="w-100-p">
      <mat-chip *ngFor="let organization of (organizationsService?.selectedOrganizationArray$|async);let first = first;"
        (removed)="remove(organization)">
        <mat-icon matChipAvatar>home</mat-icon>
        <span class="label">{{organization?.name || 'unknown?'}}</span>
        <button matChipRemove>
          <mat-icon>cancel</mat-icon>
        </button>
      </mat-chip>
    </mat-chip-set>
  </div>

  <div class="project-list w-100-p mt-16">
    <app-projects-list mode="comboMulti"
      *appIfUserHas="['CAN_SELECT_MULTIPLE_PROJECTS']; else simpleSelect"></app-projects-list>
    <ng-template #simpleSelect>
      <app-projects-list mode="combo"></app-projects-list>
    </ng-template>
  </div>

  <div appFlex class="nb-surveys" *appIfUserHas="['GOD_MODE']">
    <app-refresh-remote></app-refresh-remote>
    <div (click)="refreshSurveys()" class="margin-top-16" appFlexLayout="row"
      [matTooltip]="(surveysService.surveysListAsArray$|async).length + ' questionnaires.'|translate">
      <mat-icon class="secondary-text mt-4" fontSet="material-icons-outlined">fact_check</mat-icon>
      <div class="ml-8">{{(surveysService.surveysListAsArray$|async).length}}</div>
    </div>
  </div>

</div>
